import {
    loadInvoiceDataForPrintView as _loadInvoiceDataForPrintView,
    stornoPosTerminalInvoice as _stornoPosTerminalInvoice,
    getReservationInvoicePreview,
    getReservationGroupInvoicePreview,
    editConcludedInvoice as _editConcludedInvoice,
    updateAdvanceTimestamp as _updateAdvanceTimestamp,
} from './api';
import { getBelongingGroupReservation, setReservationInvoiceProperties } from '../checkout/api';
import {
    GroupInvoiceDetails,
    GroupInfoWithReservations,
    InvoiceModelWithInvoiceItems,
    ReservationModelWithModelsIncluded,
} from '@common/modelDefinition';
import useStore from '@data/state/zustand';

const loadInvoiceDataForPrintView = async (invoiceId: number) => {
    clearInvoicePrintPreview();
    useStore.getState().setNestedProperty(['state', 'invoicePresenter'], {
        invoice: {},
        groupReservationsArray: [],
        refInvoice: null,
        padding: 1,
        simpleViewEnabled: null,
        invoiceToOverride: null,
    });
    const { invoice, refInvoice } = await _loadInvoiceDataForPrintView(invoiceId);
    const { groupUuid } = invoice;
    const groupReservation: GroupInfoWithReservations | null = groupUuid
        ? await getBelongingGroupReservation(groupUuid, true)  // ← DODAJ true
        : null;
    const groupReservationsArray: ReservationModelWithModelsIncluded[] = groupReservation
        ? groupReservation.Reservations
            ? groupReservation.Reservations
            : []
        : [];

    useStore
        .getState()
        .setNestedProperty(['state', 'invoicePresenter'], { invoice, groupReservationsArray, refInvoice, padding: 1 });
};

const clearInvoicePrintPreview = () => {
    useStore
        .getState()
        .setNestedProperty(['state', 'invoicePresenter', 'invoicePreview'], { invoice: {}, invoiceItems: [] });
};

const setInvoiceProperty = (propertyName: string, value: string) => {
    // samo locale i currency
    useStore.getState().setNestedProperty(['state', 'invoicePresenter', 'invoice', ...[propertyName]], value);
};

const stornoInvoiceByIdAndWithReclamationNote = async (
    invoiceId: number,
    reclamationReason: string | null,
    terminalType: string = 'reservation'
) => {
    if (reclamationReason === null) {
        throw new Error('You have to give a reason for storning invoice?');
    }
    if (terminalType === 'reservation' || terminalType === 'reservationConsumption') {
        const properties = { reclamation: 1, reclamationReason };
        const { invoice, invoiceItems, stornoInvoices } = await setReservationInvoiceProperties({invoiceId, properties});
        useStore.getState().setNestedProperty(['state', 'invoicePresenter'], { invoice, invoiceItems, stornoInvoices });
    } else if (terminalType === 'posTerminal' || terminalType === 'minibar') {
        const { invoice, invoiceItems, stornoInvoices } = await _stornoPosTerminalInvoice(
            invoiceId,
            reclamationReason,
            terminalType
        );
        useStore.getState().setNestedProperty(['state', 'invoicePresenter'], { invoice, invoiceItems, stornoInvoices });
    }
};



const editConcludedInvoice = async (invoice: InvoiceModelWithInvoiceItems) => {
    if (invoice.id) {
        await _editConcludedInvoice(invoice);
        useStore.getState().setNestedProperty(['state', 'invoicePresenter'], { invoice });
    }
};

const loadInvoicePreview = async (reservationId: number) => {
    useStore.getState().setNestedProperty(['state', 'invoicePresenter', 'groupInvoiceDetails'], {});
    const { invoice, invoiceItems } = await getReservationInvoicePreview(reservationId);
    invoice.reservationId = reservationId;
    useStore.getState().setNestedProperty(['state', 'invoicePresenter', 'invoicePreview'], { invoice, invoiceItems });
};

const getIssuedStornoInvoice = (invoiceId: number) => {
    const stornoInvoices: InvoiceModelWithInvoiceItems[] = useStore.getState().state.invoicePresenter.stornoInvoices;
    const issuedStornoInvoice: InvoiceModelWithInvoiceItems | undefined | null =
        stornoInvoices && stornoInvoices.length > 0 ? stornoInvoices.find((i) => i.refInvoice === invoiceId) : null;
    return issuedStornoInvoice;
};

const loadGroupInvoiceDetails = async (groupUuid: string | null) => {
    if (!groupUuid) {
        return null;
    }
    const groupInvoiceDetails: GroupInvoiceDetails = useStore.getState().state.invoicePresenter.groupInvoiceDetails;
    if (
        groupInvoiceDetails &&
        Object.keys(groupInvoiceDetails).length > 0 &&
        groupInvoiceDetails.constructor === Object
    ) {
        useStore.getState().setNestedProperty(['state', 'invoicePresenter', 'groupInvoiceDetails'], {});
    } else {
        clearInvoicePrintPreview();
        const invoices: GroupInvoiceDetails = await getReservationGroupInvoicePreview(groupUuid);
        useStore.getState().setNestedProperty(['state', 'invoicePresenter', 'groupInvoiceDetails'], invoices);
    }
};

const handlePadding = () => {
    let currentPadding = useStore.getState().state.invoicePresenter.padding;
    const newPadding = currentPadding !== 3 ? currentPadding + 1 : 0;
    useStore.getState().setNestedProperty(['state', 'invoicePresenter', 'padding'], newPadding);
};

const updateAdvanceTimestamp = async (invoice: InvoiceModelWithInvoiceItems) => {
    if (invoice.id) {
        await _updateAdvanceTimestamp(invoice);
        useStore.getState().setNestedProperty(['state', 'invoicePresenter'], { invoice });
    }
};

const setStornoPreview = async (invoice: InvoiceModelWithInvoiceItems,refInvoice: InvoiceModelWithInvoiceItems) => {
    clearInvoicePrintPreview();  
    useStore
        .getState()
        .setNestedProperty(['state', 'invoicePresenter'], { invoice, invoiceItems:invoice.InvoiceItems,refInvoice });
};

export {
    loadInvoiceDataForPrintView,
    setInvoiceProperty,
    stornoInvoiceByIdAndWithReclamationNote,
    loadInvoicePreview,
    clearInvoicePrintPreview,
    getIssuedStornoInvoice,
    loadGroupInvoiceDetails,
    editConcludedInvoice,
    handlePadding,
    updateAdvanceTimestamp,
    setStornoPreview
};
